import type { KeyboardEvent, PointerEvent } from "react";

const STEP = 16;

export function ResizeHandle({
  label,
  width,
  onResize,
  onReset,
}: {
  label: string;
  width: number;
  onResize: (width: number) => void;
  onReset: () => void;
}) {
  const onPointerDown = (event: PointerEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    const handle = event.currentTarget;
    const start = event.clientX;
    const base = width;
    handle.setPointerCapture(event.pointerId);
    const move = (e: globalThis.PointerEvent) => {
      onResize(base + e.clientX - start);
    };
    const up = () => {
      handle.removeEventListener("pointermove", move);
      handle.removeEventListener("pointerup", up);
    };
    handle.addEventListener("pointermove", move);
    handle.addEventListener("pointerup", up);
  };
  const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
      event.preventDefault();
      event.stopPropagation();
      onResize(width + (event.key === "ArrowRight" ? STEP : -STEP));
    } else if (event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      onReset();
    }
  };
  return (
    <div
      role="separator"
      aria-orientation="vertical"
      aria-label={`Resize ${label}`}
      aria-valuenow={Math.round(width)}
      aria-valuemin={48}
      tabIndex={0}
      onPointerDown={onPointerDown}
      onKeyDown={onKeyDown}
      onClick={(e) => {
        e.stopPropagation();
      }}
      onDoubleClick={(e) => {
        e.stopPropagation();
        onReset();
      }}
      className="absolute inset-y-0 right-0 w-1.5 cursor-col-resize touch-none opacity-0 hover:bg-link/40 hover:opacity-100 focus-visible:bg-link focus-visible:opacity-100 focus-visible:outline-none"
    />
  );
}
